import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import emailIcon from "../../../assets/svgs/emailIcon.svg";
import Footer from "../../../components/Footer";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import ApiService from "../../../service/api";
import { showErrorToast, showSuccessToast } from "../../../utils/ToastsModal";
import { isValidEmail } from "../../../utils/modules";
import { Loader } from "../../../widgets/Loader";

const Login = () => {
  const navigate = useNavigate();
  const params = useParams();

  const emailRef = React.useRef(null);

  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isValidEmail(email)) {
      setEmailError(false);
    } else {
      setEmailError(true);
      emailRef.current.focus();
    }
  }, [email]);

  const handleLogin = async () => {
    if (!email) {
      emailRef.current.focus();
    } else {
      setLoading(true);
      await ApiService.loginUser({ email: email })
        .then((response) => {
          if (response.status === 200) {
            showSuccessToast(response.data?.message);
            localStorage.setItem("email", email);
            navigate(`/otp`);
          }
          setLoading(false);
        })
        .catch((error) => {
          showErrorToast(error?.request?.response);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <MobileViewLayout>
        <>
          <div
            className="text-center d-flex flex-column px-4"
            style={{
              paddingTop: "40px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <p className="mb-0 fw-bold fs30">{t("login.title")}</p>
            <h6 style={{ fontSize: "14px" }} className="text-center mb-4 mt-2">
              {t("login.description")}
            </h6>
            <div className="d-flex justify-content-center align-items-center flex-column mt-4">
              <div
                className="email-input-wrapper"
                style={{ width: "100%", marginBottom: "10px" }}
              >
                <div className="email-input-icon">
                  <img
                    src={emailIcon}
                    alt=""
                    className=""
                    style={{
                      width: "24px",
                      height: "20px",
                    }}
                  />
                </div>
                <input
                  ref={emailRef}
                  required
                  className="input-field email-input w-100"
                  placeholder={t("login.email_label")}
                  onChange={(e) => {
                    setEmail(e.target.value.toLowerCase());
                  }}
                  style={{ textTransform: email?.length > 0 && "lowercase" }}
                />
              </div>
              {emailError && (
                <p className="small align-self-start" style={{ color: "red" }}>
                  {t("login.email_placeholder")}
                </p>
              )}
              {loading ? (
                <Loader />
              ) : (
                <Button
                  className="w-100 main-button py-3 fw-bold text-white mt-1 mb-1 bgSecondary"
                  style={{ height: "55px" }}
                  onClick={handleLogin}
                >
                  {t("login.title")}
                </Button>
              )}
              <p
                className="mt-3"
                style={{
                  color: "#6C6E79",
                  fontWeight: "regular",
                  fontSize: "14px",
                }}
              >
                <Trans
                  i18nKey={"login.no_account"}
                  components={{
                    tag: (
                      <span
                        style={{ color: "#4286f5" }}
                        className="main-text text-decoration-underline"
                        onClick={() => navigate(`/${params.gender}/emailForm`)}
                      />
                    ),
                  }}
                />
              </p>
            </div>
          </div>
        </>
      </MobileViewLayout>
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-end pt-3 px-0 pb-2 ">
        <hr style={{ width: "100%" }} />
        <Footer />
      </div>
    </>
  );
};

export default Login;
